import { status } from 'skin/event/status';
import exception from './exception';

const table = (obj, form, story, data, d, action) => {
	switch (obj.table) {
		case 'exception':
			return exception(obj, form, story, data, d, action);
		default:
	}
	return status.action;
};

export default table;
